<template>
<div id="detectioninfo">
    <div class="container">
        <div class="row">
            <div class="col-sm-10">
                <p v-html="detectioninfo.msg"></p>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-lg-3 col-md-6 col-sm-12">
                        <div class="icon-h center">
                            <img class="family" src="static/icon/family.png">
                        </div>
                        <router-link to="/detection/family" class="btn m10">親情</router-link>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12">
                        <div class="icon-h center">
                            <img class="friend" src="static/icon/friend.png">
                        </div>
                        <router-link to="/detection/friend" class="btn m10">友情</router-link>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12">
                        <div class="icon-h center">
                            <img class="love" src="static/icon/love.png">
                        </div>
                        <router-link to="/detection/love" class="btn m10">愛情</router-link>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12">
                        <div class="icon-h center">
                            <img class="work" src="static/icon/work.png">
                        </div>
                        <router-link to="/detection/work" class="btn m10">職場</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container" id="ref">
        <span>參考資料：安一心「面對家人的情緒勒索」、論文「職場情緒勞動忽略的角落--情緒勒索概念分析與量表建構」</span>
    </div>
</div>
</template>

<script>
import DetectionFamily from '@/components/pages/DetectionFamily'
export default {
    name: "detectioninfo",
    data(){
        return{
            detectioninfo: {
                title: '自我檢測',
                msg: '<p>歡迎來到「迷．麋」情緒勒索檢測處，想知道自己是否深陷於情緒勒索之苦嗎？以下會針對情緒勒索的特徵提出一些問題，即使您沒感覺到情緒勒索，做個小測驗也無妨喔～這些題目可以幫助您替自己或是您關心的人來鑒別有沒有相關困擾。檢測只需三分鐘便能完成，相信對您會有幫助！<br><br>迷糜網站在情緒勒索頁面的「勒索者與被勒索者的特質」那部分有提到，由於兩類人有著共同的特質，因此在一段關係中，兩方的角色可能會互換；又或是你在一段關係中是勒索者，卻在另一段關係裡是被勒索者。因此以下四份不同關係狀態的問卷，測出來的結果若不相同是非常正常的。</p>'
            }
        }
    }
}
</script>

<style>
#detectioninfo p{
    color: #fff;
}
.fas.fa-user-clock,.far.fa-list-alt,.fas.fa-cloud-rain{
    font-size: 100px;
    color: #fff;
    margin-top: 30px;
    margin-bottom: 50px;
}

.family{
    width: 200px;
    margin-bottom: 10px;
}
.love{
    width: 250px;
}
.friend{
    width: 200px;
}
.work{
    width: 180px;
    margin-bottom: 10px;
}
.m10{
    margin-top: 30px;
}

.icon-h{
    min-height: 250px;
}

#ref span{
    color: #eee;
}

#ref{
    margin-top: 50px;
}

</style>


// WEBPACK FOOTER //
// src/components/pages/DetectionInfo.vue